import React, { useEffect, useState } from 'react';
import projectContractorsService from '@rd-web-markets/de/dist/services/project_contractor.service';
import { Row, Button, Badge, Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import ProjectContractorForm from '@rd-web-markets/de/dist/technicalProof/creating_application/ProjectContractorForm';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util/';
import yearFinancialDetailsService from '../../services/year_financial_details.service';
import { useTranslation } from 'react-i18next';
import financialDetailsDocumentsService from '../../services/financial_details_documents.service';
const currencyFormatter = new Intl.NumberFormat('de-DE', {
  minimumFractionDigits: 2
});
const ContractResearchSection = _ref => {
  let {
    report
  } = _ref;
  const contractor_type = window.location.pathname.includes('claim_costs') ? 'cost' : 'bfsz';
  const [contractors, setContractors] = useState(null);
  const [selectedContractor, setSelectedContractor] = useState(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const fetchData = async () => {
      const contractors = await projectContractorsService.all(report.id, contractor_type);
      setContractors(contractors);
    };
    fetchData();
  }, [report.id]);
  const deleteProjectContractor = async contractor => {
    if (window.confirm(t('are_you_sure_you_want_to_remove_this_contractor'))) {
      await projectContractorsService.delete(report.id, contractor.id);
      setContractors([...contractors.filter(c => c.id !== contractor.id)]);
      setSelectedContractor(null);
    }
  };
  const createProjectContractor = () => {
    setSelectedContractor({});
  };
  const closeForm = () => {
    setSelectedContractor(null);
  };
  const handleChange = e => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setSelectedContractor({
      ...selectedContractor,
      [e.target.name]: value
    });
  };
  const editProjectContractor = (e, contractor) => {
    e.preventDefault();
    setSelectedContractor(contractor);
  };
  const handleAsyncChange = (e, index) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    const updatedContractors = [...contractors];
    updatedContractors[index][e.target.name] = value;
    setContractors(updatedContractors);
  };
  const handleAsyncSubmit = async index => {
    const updatedContractor = await projectContractorsService.update(report.id, contractors[index]);
    const newContractors = [...contractors];
    newContractors[index] = updatedContractor;
    setContractors(newContractors);
  };
  const handleSubmit = async () => {
    if (Object.keys(selectedContractor).length !== 0) {
      setLoading(true);
      try {
        if (!selectedContractor.id) {
          const newContractor = await projectContractorsService.create(report.id, {
            ...selectedContractor,
            contractor_type
          });
          setContractors([...contractors, newContractor]);
          setSelectedContractor(null);
        } else {
          const updatedContractor = await projectContractorsService.update(report.id, selectedContractor);
          const newContractors = contractors;
          const index = newContractors.findIndex(c => {
            return c.id === updatedContractor.id;
          });
          newContractors[index] = updatedContractor;
          setContractors(newContractors);
          setSelectedContractor(null);
        }
      } catch (e) {
        dispatch(handleError(e));
      } finally {
        setLoading(false);
      }
    }
  };
  const handleFinancialDetailChange = async (e, id) => {
    const financialDetails = selectedContractor.financial_details;
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    financialDetails.find(detail => detail.id === id)[e.target.name] = value;
    setSelectedContractor({
      ...selectedContractor,
      financial_details: financialDetails
    });
  };
  const saveFinancialDetailChange = async financialDetail => {
    try {
      await yearFinancialDetailsService.update(selectedContractor.id, financialDetail);
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const addFile = async (detail, e) => {
    let fd = new FormData();
    fd.append('file', e);
    setLoading(true);
    try {
      await yearFinancialDetailsService.upload(detail, fd);
      const updatedProjectContractor = await projectContractorsService.get(report.id, selectedContractor.id);
      setSelectedContractor(updatedProjectContractor);
    } catch (error) {
      dispatch(handleError(error));
    } finally {
      setLoading(false);
    }
  };
  const removeAttachment = async (detail, attachmentId) => {
    setLoading(true);
    try {
      await financialDetailsDocumentsService.delete(detail.id, attachmentId);
      const updatedProjectContractor = await projectContractorsService.get(report.id, selectedContractor.id);
      setSelectedContractor(updatedProjectContractor);
    } catch (error) {
      dispatch(handleError(error));
    } finally {
      setLoading(false);
    }
  };
  const handleCreateDetail = async cost_type => {
    const financial_detail = {
      cost_type: cost_type
    };
    try {
      setLoading(true);
      const createdDetail = await yearFinancialDetailsService.create(selectedContractor.id, financial_detail);
      const financialDetails = selectedContractor.financial_details;
      financialDetails.push(createdDetail);
      setSelectedContractor({
        ...selectedContractor,
        financial_details: financialDetails
      });
    } catch (err) {
      dispatch(handleError(err));
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteDetail = async id => {
    if (window.confirm('Are you sure you want to proceed ?')) {
      try {
        setLoading(true);
        let financialDetails = selectedContractor.financial_details;
        await yearFinancialDetailsService.delete(selectedContractor.id, id);
        financialDetails = financialDetails.filter(detail => detail.id !== id);
        setSelectedContractor({
          ...selectedContractor,
          financial_details: financialDetails
        });
      } catch (err) {
        dispatch(handleError(err));
      } finally {
        setLoading(false);
      }
    }
  };
  const renderStatus = isCompleted => {
    if (isCompleted) {
      return /*#__PURE__*/React.createElement(Badge, {
        pill: true,
        bg: "success"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons text-white"
      }, "done"));
    } else {
      return /*#__PURE__*/React.createElement(Badge, {
        pill: true,
        bg: "danger"
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons text-white"
      }, "close"));
    }
  };
  const handleSetSelectedContractor = selectedContractor => {
    const index = contractors.findIndex(c => c.id === selectedContractor.id);
    contractors[index] = selectedContractor;
    setSelectedContractor(selectedContractor);
    setContractors([...contractors]);
  };
  const saveFinancialYearChange = () => {};
  if (!contractors) return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end pb-3"
  }, !selectedContractor && /*#__PURE__*/React.createElement(Button, {
    onClick: () => createProjectContractor({}),
    variant: "primary",
    disabled: report.application_submitted && contractor_type === 'bfsz',
    className: "mx-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " ", t('add_new_contractor'))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("table", {
    className: "table borderless"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("th", null, t('contractor_name')), /*#__PURE__*/React.createElement("th", null, t('status')), /*#__PURE__*/React.createElement("th", null, t('rd_work_objectives')), /*#__PURE__*/React.createElement("th", null, t('order_amount_in_euros')), /*#__PURE__*/React.createElement("th", null, t('open_detailed')), /*#__PURE__*/React.createElement("th", null, t('delete')))), /*#__PURE__*/React.createElement("tbody", {
    className: "text-center"
  }, contractors.map((contractor, index) => {
    return /*#__PURE__*/React.createElement("tr", {
      key: contractor.id
    }, /*#__PURE__*/React.createElement("td", null, contractor.research_institute_name), /*#__PURE__*/React.createElement("td", null, renderStatus(contractor.is_completed)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlighter, {
      as: Form.Control,
      onChange: e => handleAsyncChange(e, index),
      onBlur: () => handleAsyncSubmit(index),
      object: contractor,
      name: "rnd_work_objectives",
      controlAs: "textarea",
      disabled: report.application_submitted,
      rows: "5"
    })), /*#__PURE__*/React.createElement("td", {
      className: "text-center"
    }, currencyFormatter.format(contractor.total_cost)), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => editProjectContractor(e, contractor)
    }, "To Contractor Details")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      onClick: () => deleteProjectContractor(contractor),
      disabled: report.application_submitted,
      className: "mx-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "delete"))));
  })))), selectedContractor && /*#__PURE__*/React.createElement(ProjectContractorForm, {
    applicationSubmitted: report.application_submitted,
    addFile: addFile,
    removeAttachment: removeAttachment,
    handleCreateDetail: handleCreateDetail,
    handleChange: handleChange,
    contractor: selectedContractor,
    closeForm: closeForm,
    saveFinancialYearChange: saveFinancialYearChange,
    handleSubmit: handleSubmit,
    loading: loading,
    handleDeleteDetail: handleDeleteDetail,
    handleFinancialDetailChange: handleFinancialDetailChange,
    saveFinancialDetailChange: saveFinancialDetailChange,
    setSelectedContractor: handleSetSelectedContractor
  }));
};
export default ContractResearchSection;